import { useEffect, useRef, useState } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import { handleError } from '@apollo/client/link/http/parseAndCheckHttpResponse'
import { GET_ALL_GROUPS_CATEGORIES_BY_IDS } from '../../../../../graphql/Catalog/Groups/groupsCategories'
import KpiMultiCards from './KpiMultiCards'
import KpiCustomGraphicBar from './KpiCustomGraphicBar'
import {
  GET_ACTIVITY_REPORTS_COUNTERS_BY_ADMIN_MASTER,
  GET_FILTERS_OPTIONS_BY_ADMIN_MASTER_MAYOR,
} from '../../../../../graphql/Document/DashboardActivityByRol/dashboardActivityByRol'
import { GET_ALL_GROUPS_CATEGORIES_SUBS_BY_ARRAY_CATEGORY_ID } from '../../../../../graphql/Catalog/Groups/groupsCategoriesSubs'
import CategoryFilter from './CategoryFilter'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import KpiCustomGraphicLine from './KpiCustomGraphicLine'
import KpiCustomGraphicPie from './KpiCustomGraphicPie'
import AdminMasterMayorPdfTemplate from './AdminMasterMayorPdfTemplate'
import Quill from 'react-quill'
import CategoriesTableAdminMasterMayor from './SubCategoriesTableAdminMasterMayor'
import { currencyFormatToAny } from '../../../../Helpers/FormatNumber'
// import 'react-quill/dist/quill.snow.css'

const formatNumberWithCommas = (number) => {
  if (typeof number !== 'number') return number
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const DashboardAdminMasterMayor = () => {
  const MySwal = withReactContent(Swal)
  const dateType = [
    { value: 'ALL', label: 'General' },
    { value: 'YEAR', label: 'Ver por año' },
    { value: 'WEEK', label: 'Ver por semana' },
    { value: 'DAY', label: 'Ver por día' },
  ]

  //STATES
  const [filters, setFilters] = useState({
    array_group_category_id: null,
    array_group_category_sub_id: null,
    date_type: 'ALL',
    year: new Date().getFullYear().toString(),
    month: null,
    week: null,
    special_priority: false,
  })

  const [options, setOptions] = useState({
    categories: [],
    subcategories: [],
    years: [],
    months: [],
    weeks: [],
  })
  const [counters, setCounters] = useState({
    generated: 0,
    in_process: 0,
    resolved: 0,
    effectiveness: 0,
    web: 0,
    app: 0,
    tlajochat: 0,
    categories: [],
    categoriesOrigin: [],
    counterByDateFilterCategories: [],
    counterByDateFilter: null,
    counterByDateFilterOptions: null,
    counterByDateFilterLines: null,
    counterByDateFilterLinesOptions: null,
    countersByDateFilterPie: null,
    countersByDateFilterPieOptions: null,
  })
  const [activeSort, setActiveSort] = useState(null) // 'asc' o 'desc'
  const [showSubcategories, setShowSubcategories] = useState(false) // Mostrar subcategorías o no
  const [showElementsController, setShowElementsController] = useState({
    graphicsPie: false,
    dynamicTable: false,
    horizontalPage: true,
  })
  const [quillContent, setQuillContent] = useState('') // Nuevo estado para Quill

  const [pdfController, setPdfController] = useState({
    loading: false,
    hideElements: false,
    notes: null,
  })

  //QUERIES AND MUTATIONS
  const {
    data: dataCategories,
    loading: loadingCategories,
    error: errorCategories,
  } = useQuery(GET_ALL_GROUPS_CATEGORIES_BY_IDS, {
    variables: { flag_group_id: true },
    fetchPolicy: 'no-cache',
  })

  const {
    data: dataCounters,
    loading: loadingCounters,
    error: errorCounters,
  } = useQuery(GET_ACTIVITY_REPORTS_COUNTERS_BY_ADMIN_MASTER, {
    variables: {
      filters,
    },
    fetchPolicy: 'no-cache',
  })

  const [getFiltersOptions] = useMutation(
    GET_FILTERS_OPTIONS_BY_ADMIN_MASTER_MAYOR
  )

  const [getSubCategories] = useMutation(
    GET_ALL_GROUPS_CATEGORIES_SUBS_BY_ARRAY_CATEGORY_ID
  )

  //EFFECTS
  useEffect(() => {
    if (!loadingCounters) {
      if (errorCounters) return handleError(errorCounters.message)
      if (dataCounters?.getActivityReportsCountersByAdminMasterMayor) {
        const dataFetch =
          dataCounters.getActivityReportsCountersByAdminMasterMayor

        //Por default acomodar de mayor a menor las categorias
        const sortedCategories = [...dataFetch?.categories].sort(
          (a, b) => b.percentage - a.percentage
        )
        setActiveSort('desc') // Activa el botón

        // let subCategories = []
        // subCategories = sortedCategories.flatMap(
        //   (cat) => cat.subcategories || []
        // )

        let counterByDateFilter = null
        let counterByDateFilterLines = null
        let counterByDateFilterOptions = null
        let counterByDateFilterLinesOptions = null
        let countersByDateFilterPie = null
        let countersByDateFilterPieOptions = null

        // Ordenar las categorías de cada periodo por quantity de manera descendente
        let counterByDateFilterCategories = (
          dataFetch?.counterByDateFilter || []
        ).map((period) => ({
          ...period,
          categories: Array.isArray(period.categories)
            ? [...period.categories].sort(
                (a, b) => (b.quantity || 0) - (a.quantity || 0)
              )
            : [],
        }))

        // Función para obtener el detalle extra por barra
        const getCategoriesDetails = (label, category, stack) => {
          const findCounter = dataFetch?.counterByDateFilter.find(
            (counter) => counter.label?.toLowerCase() === label?.toLowerCase()
          )
          if (findCounter) {
            const { categories } = findCounter
            const details = categories
              .filter((item) => item.name !== category)
              .map((item) => {
                return `${item.name}: ${formatNumberWithCommas(
                  stack == 'categoriesGenerated'
                    ? item?.quantity || 0
                    : item?.resolved || 0
                )}`
              })
            return details // Return as array for Chart.js tooltip to render each as a new line
          }
          return null
        }

        // Opciones para tooltips personalizados
        const tooltip = {
          callbacks: {
            label: function (context) {
              // Valor original
              const value =
                context.parsed.y !== undefined
                  ? context.parsed.y
                  : context.parsed
              // Detalle extra
              const extra = getCategoriesDetails(
                context?.label,
                context?.dataset?.label,
                context?.dataset?.stack
              )
              let label = `${
                context.dataset.label || ''
              }: ${formatNumberWithCommas(value)}`
              if (extra) {
                // If extra is an array, return an array for multiline tooltip
                return [label, ...(Array.isArray(extra) ? extra : [extra])]
              }
              return label
            },
          },
        }

        if (dataFetch?.counterByDateFilter) {
          // Obtener todas las subcategorías únicas de todos los periodos
          const allCategories = {}
          dataFetch?.counterByDateFilter?.forEach((item) => {
            ;(item.categories || []).forEach((sub) => {
              allCategories[sub.name] = sub
            })
          })
          // Ordenar las categorías por quantity de manera descendente y guardar en allCategories
          let sortedCategoryEntries = Object.entries(allCategories).sort(
            (a, b) => (b[1]?.quantity || 0) - (a[1]?.quantity || 0)
          )
          // Reconstruir allCategories ordenado
          let orderedAllCategories = {}
          sortedCategoryEntries.forEach(([name, obj]) => {
            orderedAllCategories[name] = obj
          })
          // Usar las categorías ordenadas para los nombres
          let categoryNames = Object.keys(orderedAllCategories)

          // Para cada subcategoría, construir dos datasets: generados y en proceso
          const generatedDatasets = categoryNames?.map((subName, idx) => {
            // HSL hue for gray
            // Interpolar entre #4B5563 (75, 85, 99) y #D9E7EA (217, 231, 234)
            const startColor = { r: 75, g: 85, b: 99 }
            const endColor = { r: 217, g: 231, b: 234 }
            const t =
              categoryNames.length > 1 ? idx / (categoryNames.length - 1) : 0
            const r = Math.round(startColor.r + (endColor.r - startColor.r) * t)
            const g = Math.round(startColor.g + (endColor.g - startColor.g) * t)
            const b = Math.round(startColor.b + (endColor.b - startColor.b) * t)
            const generatedColor = `rgb(${r}, ${g}, ${b})`

            // Saturación y luminosidad fijas para mantener el estilo
            const found = dataFetch?.counterByDateFilter?.find((item) =>
              (item.categories || []).some((sub) => sub.name === subName)
            )
            if (found) {
              const sub = (found.categories || []).find(
                (sub) => sub.name === subName
              )
              // Actualizar el color en counterByDateFilterCategories
              if (
                counterByDateFilterCategories &&
                Array.isArray(counterByDateFilterCategories) &&
                sub?.id
              ) {
                counterByDateFilterCategories?.forEach((period) => {
                  if (Array.isArray(period.categories)) {
                    period.categories.forEach((subcat) => {
                      if (subcat.id === sub.id) {
                        // subcat.generatedColor = generatedColors[idx % generatedColors.length]
                        subcat.generatedColor = generatedColor
                      }
                    })
                  }
                })
              }
            }
            return {
              label: `${subName}`,
              data: dataFetch?.counterByDateFilter?.map((item) => {
                const found = (item.categories || []).find(
                  (sub) => sub.name === subName
                )
                return found ? found.quantity || 0 : 0
              }),
              backgroundColor: generatedColor,
              borderColor: '#fff',
              borderWidth: 1,
              maxBarThickness: 140,
              stack: 'categoriesGenerated', // Apilar por categoría
            }
          })

          // Ordenar las categorías por resolved de manera descendente y guardar en allCategories
          sortedCategoryEntries = Object.entries(allCategories).sort(
            (a, b) => (b[1]?.resolved || 0) - (a[1]?.resolved || 0)
          )
          // Reconstruir allCategories ordenado
          orderedAllCategories = {}
          sortedCategoryEntries.forEach(([name, obj]) => {
            orderedAllCategories[name] = obj
          })
          // Usar las categorías ordenadas para los nombres
          categoryNames = Object.keys(orderedAllCategories)

          const inProcessDatasets = categoryNames?.map((subName, idx) => {
            // Interpolar entre #F97316 (249, 115, 22) y #FFDAC4 (255, 218, 196)
            const startColor = { r: 249, g: 115, b: 22 }
            const endColor = { r: 255, g: 218, b: 196 }
            const t =
              categoryNames.length > 1 ? idx / (categoryNames.length - 1) : 0
            const r = Math.round(startColor.r + (endColor.r - startColor.r) * t)
            const g = Math.round(startColor.g + (endColor.g - startColor.g) * t)
            const b = Math.round(startColor.b + (endColor.b - startColor.b) * t)
            const resolvedColor = `rgb(${r}, ${g}, ${b})`

            const found = dataFetch?.counterByDateFilter?.find((item) =>
              (item.categories || []).some((sub) => sub.name === subName)
            )
            if (found) {
              const sub = (found.categories || []).find(
                (sub) => sub.name === subName
              )
              // Actualizar el color en counterByDateFilterCategories
              if (
                counterByDateFilterCategories &&
                Array.isArray(counterByDateFilterCategories) &&
                sub?.id
              ) {
                counterByDateFilterCategories?.forEach((period) => {
                  if (Array.isArray(period.categories)) {
                    period.categories.forEach((subcat) => {
                      if (subcat.id === sub.id) {
                        subcat.inProcessColor = resolvedColor
                      }
                    })
                  }
                })
              }
            }
            return {
              label: `${subName}`,
              data: dataFetch?.counterByDateFilter?.map((item) => {
                const found = (item.categories || []).find(
                  (sub) => sub.name === subName
                )
                return found ? found.resolved || 0 : 0
              }),
              backgroundColor: resolvedColor,
              borderColor: '#fff',
              borderWidth: 1,
              maxBarThickness: 140,
              stack: 'categoriesResolved', // Apilar por subcategoría
            }
          })

          const datasets = [...generatedDatasets, ...inProcessDatasets]

          if (datasets.length > 0)
            counterByDateFilter = {
              labels: dataFetch?.counterByDateFilter?.map(
                (item) =>
                  item.label.charAt(0).toUpperCase() + item.label.slice(1)
              ),
              datasets,
            }
          else
            counterByDateFilter = {
              labels: dataFetch?.counterByDateFilter?.map(
                (item) =>
                  item.label.charAt(0).toUpperCase() + item.label.slice(1)
              ),
              datasets: [
                {
                  label: 'Generados',
                  data: [],
                  backgroundColor: '#F97316',
                  borderColor: '#F97316',
                  borderWidth: 1,
                  maxBarThickness: 140,
                  dataReports: [],
                },
                {
                  label: 'Atendidos',
                  data: [],
                  backgroundColor: '#9CA3AF',
                  borderColor: '#9CA3AF',
                  borderWidth: 1,
                  maxBarThickness: 140,
                  dataReports: [],
                },
              ],
            }

          // counterByDateFilter = {
          //   labels: dataFetch?.counterByDateFilter.map(
          //     (item) => item.label.charAt(0).toUpperCase() + item.label.slice(1)
          //   ),
          //   datasets: [
          //     {
          //       label: 'Generados',
          //       data: dataFetch?.counterByDateFilter.map(
          //         (item) => item.generated
          //       ),
          //       backgroundColor: '#F97316',
          //       borderColor: '#F97316',
          //       borderWidth: 1,
          //       maxBarThickness: 140,
          //       dataReports: dataFetch?.counterByDateFilter.map(
          //         (item) => item.generated
          //       ),
          //     },
          //     {
          //       label: 'Atendidos',
          //       data: dataFetch?.counterByDateFilter.map(
          //         (item) => item.resolved
          //       ),
          //       backgroundColor: '#9CA3AF',
          //       borderColor: '#9CA3AF',
          //       borderWidth: 1,
          //       maxBarThickness: 140,
          //       dataReports: dataFetch?.counterByDateFilter.map(
          //         (item) => item.resolved
          //       ),
          //     },
          //   ],
          // }

          counterByDateFilterLines = {
            labels: dataFetch?.counterByDateFilter.map(
              (item) => item.label.charAt(0).toUpperCase() + item.label.slice(1)
            ),
            datasets: [
              {
                label: 'Atendidos',
                data: dataFetch?.counterByDateFilter.map(
                  (item) => item.effectiveness
                ),
                borderColor: '#F97316',
                backgroundColor: '#F97316',
                tension: 0, // Suavizar las líneas
              },
            ],
          }
          counterByDateFilterOptions = {
            responsive: true,
            plugins: {
              legend: {
                display: false,
                position: 'right',
                labels: {
                  font: {
                    size: 15, // Aumentar el tamaño de los labels
                    weight: 'bold', // Hacer los labels en negrita
                  },
                  padding: 20,
                },
              },
              datalabels: {
                display: false,
                anchor: 'end',
                align: 'top',
                formatter: (value) => value,
                color: '#000',
                font: {
                  size: 15,
                  weight: 'bold',
                },
                offset: -15,
              },
              tooltip,
            },
            scales: {
              y: {
                beginAtZero: true,
                // stacked: true,
              },
              x: {
                // stacked: true,
                ticks: {
                  color: '#4A4A4A', // Cambiar color de las etiquetas
                  font: {
                    size: 15, // Cambiar tamaño de fuente
                    weight: 'bold', // Cambiar peso de la fuente
                  },
                },
              },
            },
          }

          counterByDateFilterLinesOptions = {
            responsive: true,
            plugins: {
              legend: {
                display: false,
                position: 'right',
                labels: {
                  font: {
                    size: 15, // Aumentar el tamaño de los labels
                    weight: 'bold', // Hacer los labels en negrita
                  },
                  padding: 20,
                },
              },
              datalabels: {
                anchor: 'end',
                align: 'top',
                formatter: function (value) {
                  return value.toFixed(2) + '%'
                },
                color: '#000',
                font: {
                  size: 15,
                  weight: 'bold',
                },
                offset: -15,
              },
              tooltip: {
                callbacks: {
                  label: function (context) {
                    return `${context.dataset.label}: ${context.raw}%`
                  },
                },
              },
            },
            scales: {
              x: {
                offset: true,
                title: {
                  display: true,
                  text:
                    filters?.date_type === 'ALL'
                      ? 'Total'
                      : filters?.date_type === 'YEAR'
                      ? 'Anuales'
                      : filters?.date_type === 'MONTH'
                      ? 'Mensuales'
                      : filters?.date_type === 'WEEK'
                      ? 'Semanales'
                      : filters?.date_type === 'DAY'
                      ? 'Diarios'
                      : 'Total',
                },
                ticks: {
                  color: '#4A4A4A', // Cambiar color de las etiquetas
                  font: {
                    size: 15, // Cambiar tamaño de fuente
                    weight: 'bold', // Cambiar peso de la fuente
                  },
                },
              },
              y: {
                title: {
                  display: true,
                  text: '',
                },
                beginAtZero: true,
                ticks: {
                  // callback: function (value) {
                  //   return value.toFixed(2) // Asegurar dos decimales
                  // },
                },
              },
            },
          }
        } else {
          // Si no hay datos, limpiar la gráfica de barras
          counterByDateFilter = {
            labels: [],
            datasets: [],
          }
          counterByDateFilterLines = {
            labels: [],
            datasets: [],
          }
        }

        // Calcular porcentajes de cada canal respecto al total
        let webPercentage = 0
        let appPercentage = 0
        let tlajochatPercentage = 0
        const totalChannels =
          (dataFetch?.web || 0) +
          (dataFetch?.app || 0) +
          (dataFetch?.tlajochat || 0)
        if (totalChannels > 0) {
          webPercentage = ((dataFetch?.web || 0) / totalChannels) * 100
          appPercentage = ((dataFetch?.app || 0) / totalChannels) * 100
          tlajochatPercentage =
            ((dataFetch?.tlajochat || 0) / totalChannels) * 100
        }

        countersByDateFilterPie = {
          labels: ['Web', 'App', 'Tlajochat'],
          datasets: [
            {
              data: [webPercentage, appPercentage, tlajochatPercentage],
              backgroundColor: ['#F97316', '#FC8C3C', '#FEA35E'],
              hoverBackgroundColor: ['#F97316', '#FC8C3C', '#FEA35E'],
            },
          ],
        }

        countersByDateFilterPieOptions = {
          responsive: true,
          plugins: {
            legend: {
              position: 'bottom',
              labels: {
                font: {
                  color: '#4B5563',
                  size: 12, // Aumentar el tamaño de los labels
                },
              },
            },
            datalabels: {
              anchor: 'end',
              align: 'end',
              offset: -30, // Posicionar los valores dentro de las barras
              backgroundColor: 'rgba(0, 0, 0, 0.7)', // Fondo negro semi-transparente
              borderRadius: 4, // Bordes redondeados
              color: '#FFFFFF', // Color del texto
              padding: 4, // Espaciado interno
              font: {
                size: 10, // Tamaño pequeño de la letra
              },
              formatter: function (value) {
                return value.toFixed(2) + '%'
              },
            },
            tooltip: {
              enabled: true,
            },
          },
          scales: {
            y: {
              display: false, // Ocultar eje Y
            },
            x: {
              display: false, // Ocultar eje X
              ticks: {
                color: '#4A4A4A', // Cambiar color de las etiquetas
                font: {
                  size: 15, // Cambiar tamaño de fuente
                  weight: 'bold', // Cambiar peso de la fuente
                },
              },
            },
          },
        }

        setCounters({
          generated: dataFetch?.generated,
          in_process: dataFetch?.in_process,
          resolved: dataFetch?.resolved,
          effectiveness: dataFetch?.effectiveness,
          tlajochat: dataFetch?.tlajochat,
          web: dataFetch?.web,
          app: dataFetch?.app,
          generalPercentage: dataFetch?.generalPercentage,
          categories: sortedCategories,
          categoriesOrigin: dataFetch?.categories,
          counterByDateFilterCategories,
          counterByDateFilter,
          counterByDateFilterLines,
          counterByDateFilterOptions,
          counterByDateFilterLinesOptions,
          countersByDateFilterPie,
          countersByDateFilterPieOptions,
        })
      }
    }
  }, [dataCounters, loadingCounters, errorCounters])

  useEffect(() => {
    if (!loadingCategories) {
      if (errorCategories) return handleError(errorCategories.message)
      if (dataCategories?.categories.length === 0) {
        setOptions({
          ...options,
          categories: [],
        })
        return
      }

      let categories = []
      dataCategories?.categories?.map((category) => {
        categories.push({
          value: category.id,
          label: category.name,
        })
      })

      setOptions({
        ...options,
        categories: categories,
      })
    }
  }, [dataCategories, loadingCategories, errorCategories])

  //FUNCTIONS
  const handleChangeFilterCategories = async (selected) => {
    if (selected?.length === 0) {
      setFilters({
        ...filters,
        array_group_category_id: null,
        array_group_category_sub_id: null,
      })
      setOptions({ ...options, subcategories: [] })
      return
    }

    //Optener las subcategorias de las categorias seleccionadas
    const {
      data: { getAllGroupsCategoriesSubByArrayCategoryId: subsCategories },
    } = await getSubCategories({
      variables: {
        array_group_category_id: selected.map((item) => item.value),
      },
    })

    let listSubCategories = []

    if (subsCategories?.length > 0) {
      subsCategories.map((sub) => {
        listSubCategories.push({
          value: sub.id,
          label: sub.name,
          group_category_id: sub.group_category_id,
        })
      })
    }

    setOptions({
      ...options,
      subcategories: listSubCategories,
    })

    setFilters({
      ...filters,
      array_group_category_id: selected.map((item) => item.value),
    })
  }

  const handleChangeFilterCategoriesSub = async (selected) => {
    if (selected?.length === 0) {
      return setFilters({ ...filters, array_group_category_sub_id: null })
    }

    setFilters({
      ...filters,
      array_group_category_sub_id: selected.map((item) => item.value),
    })
  }

  const handleGeneratePdf = () => {
    //Add notes modal
    let modalMsdg = ''
    MySwal.fire({
      title: 'Exportar reporte',
      html: (
        <>
          <div className="message-container d-flex flex-column gap-3 mt-3">
            <div className="d-flex text-left gap-3" style={{ width: '100%' }}>
              <div className="input-container" style={{ width: '99%' }}>
                <label htmlFor="notes-editor" style={{ paddingLeft: '4px' }}>
                  Añadir alguna observación
                </label>
                <br />
                <Quill
                  id="notes-editor"
                  theme="snow"
                  value={quillContent}
                  onChange={(content, delta, source, editor) => {
                    // Limitar a 250 caracteres de texto plano
                    const plainText = editor.getText()
                    if (plainText.length > 200) {
                      // Solo permitir los primeros 200 caracteres
                      const trimmed = plainText.slice(0, 200)
                      // Obtener el HTML correspondiente a los primeros 200 caracteres
                      // Esto elimina el exceso de texto plano, pero puede dejar etiquetas HTML abiertas
                      // Para simplicidad, solo actualizamos el contenido plano
                      setQuillContent(trimmed)
                      modalMsdg = (
                        <div dangerouslySetInnerHTML={{ __html: trimmed }} />
                      )
                    } else {
                      setQuillContent(content)
                      modalMsdg = (
                        <div dangerouslySetInnerHTML={{ __html: content }} />
                      )
                    }
                  }}
                />
                <div style={{ fontSize: '0.8em', color: '#888', marginTop: 4 }}>
                  Máximo 200 caracteres
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-end mt-3">
            <button
              type="button"
              className="btn btn-migrates mt-1 mr-3"
              onClick={() => document.querySelector('.swal2-confirm')?.click()}
            >
              Exportar reporte
            </button>
          </div>
        </>
      ),
      allowOutsideClick: true,
      buttonsStyling: false,
      showDenyButton: false,
      showConfirmButton: true,
      confirmButtonText: 'Exportar reporte',
      denyButtonText: 'Cancelar',
      customClass: {
        title: 'StandarModalTitleBackgroundNone',
        htmlContainer: 'StandarModalHtmlContainer standarModalAvoidFooter',
        confirmButton: 'btn btn-migrates d-none',
        footer: 'btn StandarModalFooterLogOut',
      },
    })
      .then((result) => {
        setQuillContent('')
        if (result.isConfirmed) {
          setPdfController({
            ...pdfController,
            notes: modalMsdg,
            loading: true,
            hideElements: true,
          })
          let timerInterval
          MySwal.fire({
            title: 'Generando PDF',
            html: 'Esto tomará un momento',
            timer: 2000,
            timerProgressBar: true,
            didOpen: () => {
              Swal.showLoading()
            },
            willClose: () => {
              clearInterval(timerInterval)
            },
          }).then((result) => {
            if (result.dismiss === Swal.DismissReason.timer) {
              setPdfController({
                ...pdfController,
                notes: null,
                loading: false,
                hideElements: false,
              })
            }
          })
        }
      })
      .catch((error) => {})
  }

  const handleChangeYear = async (e) => {
    if (filters.date_type === 'YEAR') {
      setFilters((prev) => ({
        ...prev,
        year: e.value,
      }))
      return
    }
    //Fetch options for months and weeks based on the selected year
    try {
      const { data } = await getFiltersOptions({
        variables: {
          filters: {
            array_group_category_id: filters.array_group_category_id,
            date_type: filters.date_type,
            year: e.value,
          },
        },
      })
      if (filters.date_type === 'WEEK') {
        setOptions((prev) => ({
          ...prev,
          // years: data?.getFiltersOptionsByAdminMasterMayor?.years,
          months: data?.getFiltersOptionsByAdminMasterMayor?.months,
          weeks: [],
        }))
        setFilters((prev) => ({
          ...prev,
          // year: data?.getFiltersOptionsByAdminMasterMayor?.years[0],
          year: e.value,
          month:
            data?.getFiltersOptionsByAdminMasterMayor?.months.slice(-1)[0]
              ?.value,
          week: null,
        }))
      } else if (filters.date_type === 'DAY') {
        setOptions((prev) => ({
          ...prev,
          // years: data?.getFiltersOptionsByAdminMasterMayor?.years,
          year: e.value,
          weeks: data?.getFiltersOptionsByAdminMasterMayor?.weeks,
          months: [],
        }))
        setFilters((prev) => ({
          ...prev,
          // year: data?.getFiltersOptionsByAdminMasterMayor?.years[0],
          year: e.value,
          month: null,
          week: data?.getFiltersOptionsByAdminMasterMayor?.weeks.slice(-1)[0]
            ?.value,
        }))
      }
    } catch (error) {
      console.error('Error fetching options:', error)
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  const handleOnChangeDateType = async (value) => {
    try {
      const { data } = await getFiltersOptions({
        variables: {
          filters: {
            array_group_category_id: filters.array_group_category_id,
            date_type: value,
            year: filters.year,
          },
        },
      })
      if (value === 'YEAR') {
        setOptions((prev) => ({
          ...prev,
          years: data?.getFiltersOptionsByAdminMasterMayor?.years,
          months: [],
          weeks: [],
        }))
        setFilters((prev) => ({
          ...prev,
          date_type: value,
          year: data?.getFiltersOptionsByAdminMasterMayor?.years[0],
          month: null,
          week: null,
        }))
      } else if (value === 'WEEK') {
        setOptions((prev) => ({
          ...prev,
          years: data?.getFiltersOptionsByAdminMasterMayor?.years,
          months: data?.getFiltersOptionsByAdminMasterMayor?.months,
          weeks: [],
        }))
        setFilters((prev) => ({
          ...prev,
          date_type: value,
          year: data?.getFiltersOptionsByAdminMasterMayor?.years[0],
          month:
            data?.getFiltersOptionsByAdminMasterMayor?.months.slice(-1)[0]
              ?.value,
          week: null,
        }))
      } else if (value === 'DAY') {
        setOptions((prev) => ({
          ...prev,
          years: data?.getFiltersOptionsByAdminMasterMayor?.years,
          weeks: data?.getFiltersOptionsByAdminMasterMayor?.weeks,
          months: [],
        }))
        setFilters((prev) => ({
          ...prev,
          date_type: value,
          year: data?.getFiltersOptionsByAdminMasterMayor?.years[0],
          month: null,
          week: data?.getFiltersOptionsByAdminMasterMayor?.weeks.slice(-1)[0]
            ?.value,
        }))
      } else {
        setOptions((prev) => ({
          ...prev,
          years: [],
          weeks: [],
          months: [],
        }))
        setFilters((prev) => ({
          ...prev,
          date_type: value,
          year: new Date().getFullYear().toString(),
          month: null,
          week: null,
        }))
      }
      return
    } catch (error) {
      console.error('Error fetching options:', error)
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    }
  }

  const handleSetPrioritySpecial = (value) => {
    setFilters((prev) => ({
      ...prev,
      special_priority: value,
    }))
  }

  return (
    <>
      {pdfController.hideElements ? (
        <div>
          <AdminMasterMayorPdfTemplate
            filters={filters}
            pdfController={{
              ...pdfController,
              dynamicTable: showElementsController.dynamicTable,
              horizontalPage: showElementsController.horizontalPage,
            }}
            counters={counters}
            options={options}
          />
        </div>
      ) : (
        <div className={`row px-3 py-3 dashboard-admin-master-mayor`}>
          {/**Header */}
          <div className="col-12 header-box">
            <span className="text-center">
              Aquí tienes un resumen de lo que está pasando el día de hoy.
            </span>
            <button className='btn btn-purple' onClick={handleGeneratePdf}>Descargar reporte</button>
          </div>

          {/**Filters */}
          <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 filters-box">
            <div className="row mb-4">
              <CategoryFilter
                titleContent={<label>Ver por{` `}</label>}
                placeholder="Todos los reportes"
                options={dateType}
                onChange={(e) => {
                  handleOnChangeDateType(e.value)
                }}
                showValue={true}
                value={dateType.find(
                  (item) => item.value === filters.date_type
                )}
                isMulti={false}
              />
            </div>
            {(filters.date_type === 'YEAR' ||
              filters.date_type === 'WEEK' ||
              filters.date_type === 'DAY') && (
              <div className="row mb-4">
                <CategoryFilter
                  titleContent={<label>Año</label>}
                  placeholder="Selecciona un año"
                  options={options.years.map((year) => ({
                    value: year,
                    label: year,
                  }))}
                  onChange={(e) => handleChangeYear(e)}
                  showValue={true}
                  value={{ value: filters.year, label: filters.year }}
                  isMulti={false}
                />
              </div>
            )}
            {filters.date_type === 'WEEK' && (
              <>
                <div className="row mb-4">
                  <CategoryFilter
                    titleContent={<label>Mes</label>}
                    placeholder="Selecciona un mes"
                    options={options.months}
                    onChange={(e) => setFilters({ ...filters, month: e.value })}
                    showValue={true}
                    value={options.months.find(
                      (item) => item.value === filters.month
                    )}
                    isMulti={false}
                  />
                </div>
              </>
            )}
            {filters.date_type === 'DAY' && (
              <>
                <div className="row mb-4">
                  <CategoryFilter
                    titleContent={<label>Semana</label>}
                    placeholder="Selecciona una semana"
                    options={options.weeks}
                    onChange={(e) => setFilters({ ...filters, week: e.value })}
                    showValue={true}
                    value={options.weeks.find(
                      (item) => item.value === filters.week
                    )}
                    isMulti={false}
                  />
                </div>
              </>
            )}
            <div className="row mb-4">
              <CategoryFilter
                titleContent={
                  <label>
                    Categorías{` `}
                    <small>(Elige una o varias opciones)</small>
                  </label>
                }
                placeholder="Todas las categorías"
                options={options.categories}
                onChange={handleChangeFilterCategories}
                showValue={true}
                value={options.categories.filter((item) =>
                  filters.array_group_category_id?.includes(item.value)
                )}
                isMulti={true}
              />
            </div>
            <div className="row">
              <CategoryFilter
                titleContent={
                  <label>
                    Subcategorías{` `}
                    <small>(Elige una o varias opciones)</small>
                  </label>
                }
                placeholder="Todas las subcategorías"
                options={options.subcategories}
                onChange={handleChangeFilterCategoriesSub}
                showValue={true}
                value={options.subcategories.filter((item) =>
                  filters.array_group_category_sub_id?.includes(item.value)
                )}
                isMulti={true}
              />
            </div>
            <div className="row">
              <label style={{ userSelect: 'none' }}>
                <div className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    checked={showElementsController.graphicsPie}
                    className="switch-filter-2"
                    onChange={() =>
                      setShowElementsController((prev) => {
                        return {
                          ...prev,
                          graphicsPie: !prev.graphicsPie,
                        }
                      })
                    }
                    style={{ marginRight: '5px' }}
                  />
                  <span style={{ fontSize: '0.8em' }}>Grafica de pastel</span>
                </div>
              </label>
            </div>
            <div className="row">
              <label style={{ userSelect: 'none' }}>
                <div className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    checked={showElementsController.horizontalPage}
                    className="switch-filter-2"
                    onChange={() =>
                      setShowElementsController((prev) => {
                        return {
                          ...prev,
                          horizontalPage: !prev.horizontalPage,
                        }
                      })
                    }
                    style={{ marginRight: '5px' }}
                  />
                  <span style={{ fontSize: '0.8em' }}>
                    Impresión horizontal
                  </span>
                </div>
              </label>
            </div>
            <div className="row">
              <label style={{ userSelect: 'none' }}>
                <div className="d-flex align-items-center">
                  <input
                    type="checkbox"
                    checked={filters.special_priority}
                    className="switch-filter-2"
                    onChange={(e) => handleSetPrioritySpecial(e.target.checked)}
                    style={{ marginRight: '5px' }}
                  />
                  <span style={{ fontSize: '0.8em' }}>
                    Gestores de cercania
                  </span>
                </div>
              </label>
            </div>
          </div>

          {/** Data and Graphics */}
          <div className="col-12 col-sm-12 col-md-9 col-lg-9 col-xl-9">
            {/**Counters */}
            <div className="row">
              <div
                className={`col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 cards-box`}
              >
                <div className="row">
                  <div className="col-12">
                    <KpiMultiCards
                      cards={[
                        {
                          title: 'Sistema de indicadores',
                          value: `${
                            counters?.generalPercentage
                              ? counters?.generalPercentage >= 80
                                ? 'Bueno'
                                : counters?.generalPercentage >= 60
                                ? 'Regular'
                                : 'Insuficiente'
                              : 'Insuficiente'
                          }`,
                          iconContent: (
                            <i className="fas fa-check colorGreen" />
                          ),
                        },
                        {
                          title: 'Porcentaje general',
                          value: `${counters?.generalPercentage || 0}%`,
                          iconContent: (
                            <i className="fas fa-check colorGreen" />
                          ),
                        },
                      ]}
                    />
                  </div>
                </div>
              </div>
              <div
                className={`col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6 percentages-by-categories-box`}
              >
                <div className="header d-flex justify-content-between align-items-center pb-2">
                  <h5 className="mb-0">Eficiencia de atención</h5>
                  <div
                    className="d-flex align-items-center flex-wrap justify-content-end"
                    style={{ gap: '0px 10px' }}
                  >
                    <div className="d-flex">
                      <label style={{ userSelect: 'none' }}>
                        <div className="d-flex align-items-center">
                          <input
                            type="checkbox"
                            checked={showSubcategories}
                            className="switch-filter-2"
                            onChange={() =>
                              setShowSubcategories((prev) => !prev)
                            }
                            style={{ marginRight: '5px' }}
                          />
                          <span style={{ fontSize: '0.8em' }}>
                            Subcategorías
                          </span>
                        </div>
                      </label>
                    </div>
                    <div>
                      <button
                        className={`btnShort btn btn-sm btn-outline-primary mr-2 ${
                          activeSort === 'desc' ? 'active' : ''
                        }`}
                        onClick={() => {
                          if (activeSort === 'desc') {
                            setActiveSort(null) // Desactiva el botón si ya está activo
                            setCounters((prev) => ({
                              ...prev,
                              categories: counters.categoriesOrigin,
                            }))
                          } else {
                            const sortedCategories = [
                              ...counters.categories,
                            ].sort((a, b) => b.percentage - a.percentage)
                            setCounters((prev) => ({
                              ...prev,
                              categories: sortedCategories,
                            }))
                            setActiveSort('desc') // Activa el botón
                          }
                        }}
                      >
                        <i className="fas fa-caret-up" />
                      </button>
                      <button
                        className={`btnShort btn btn-sm ${
                          activeSort === 'asc' ? 'active' : ''
                        }`}
                        onClick={() => {
                          if (activeSort === 'asc') {
                            setActiveSort(null) // Desactiva el botón si ya está activo
                            // Restaurar el orden original
                            setCounters((prev) => ({
                              ...prev,
                              categories: counters.categoriesOrigin,
                            }))
                          } else {
                            const sortedCategories = [
                              ...counters.categories,
                            ].sort((a, b) => a.percentage - b.percentage)
                            setCounters((prev) => ({
                              ...prev,
                              categories: sortedCategories,
                            }))
                            setActiveSort('asc') // Activa el botón
                          }
                        }}
                      >
                        <i className="fas fa-caret-down" />
                      </button>
                    </div>
                  </div>
                </div>
                <div className="body">
                  <ul>
                    {counters?.categories?.map((category, index) => {
                      const subs =
                        category?.subcategories?.length > 0
                          ? category?.subcategories
                          : null

                      return (
                        <li key={`category-${category?.name}`}>
                          <div>
                            <span className="category-info">
                              <img
                                src={category?.icon}
                                alt={`icon-category-${index}`}
                              />{' '}
                              {category?.name}
                            </span>
                            {!showSubcategories && (
                              <span className="counters">
                                {`${category?.percentage?.toFixed(2)}%`}
                                <span className="quantity">{`(${
                                  currencyFormatToAny({
                                    value: category?.resolved || 0,
                                    decimalsMin: 0,
                                    decimalsMax: 0,
                                  }) || 0
                                })`}</span>{' '}
                              </span>
                            )}
                          </div>
                          {/* Subcategorías */}
                          {showSubcategories && subs && (
                            <ul className="subcategory-list">
                              {subs.map((sub, subIdx) => (
                                <li
                                  key={`subcategory-${sub?.name}`}
                                  className="subcategory-item"
                                >
                                  <div className="subcategory-row">
                                    <span
                                      className="subcategory-info"
                                      style={{ flex: 1 }}
                                    >
                                      <img
                                        src={sub?.icon}
                                        alt={`icon-subcategory-${subIdx}`}
                                        className="subcategory-icon"
                                      />
                                      {sub?.name}
                                    </span>
                                    <span className="counters">
                                      {`${
                                        sub?.percentage?.toFixed(2) ?? '0.00'
                                      }%`}
                                      <span className="quantity">{`(${
                                        sub?.resolved || 0
                                      })`}</span>
                                    </span>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      )
                    })}
                  </ul>
                </div>
              </div>
            </div>
            {/**Graphics */}
            <div className="row graphics-box-container counters-page-break">
              {counters?.counterByDateFilter && (
                <div className="graphics-box col-12">
                  <div className="header d-flex justify-content-between align-items-center">
                    <h5 className="text-left">
                      Reportes{' '}
                      {filters?.date_type === 'ALL'
                        ? 'generales'
                        : filters?.date_type === 'YEAR'
                        ? 'anuales'
                        : filters?.date_type === 'MONTH'
                        ? 'mensuales'
                        : filters?.date_type === 'WEEK'
                        ? 'semanales'
                        : filters?.date_type === 'DAY'
                        ? 'diarios'
                        : 'generales'}
                    </h5>
                    <label style={{ userSelect: 'none' }}>
                      <div className="d-flex align-items-center">
                        <input
                          type="checkbox"
                          checked={showElementsController.dynamicTable}
                          className="switch-filter-2"
                          onChange={() =>
                            setShowElementsController((prev) => {
                              return {
                                ...prev,
                                dynamicTable: !prev.dynamicTable,
                              }
                            })
                          }
                          style={{ marginRight: '5px' }}
                        />
                        <span style={{ fontSize: '0.8em' }}>
                          Tabla dinamica
                        </span>
                      </div>
                    </label>
                  </div>

                  <div className="body">
                    <div
                      className={`legend flex-wrap`}
                      style={{ gap: '3px 45px' }}
                    >
                      <div className="legend-item" style={{ minWidth: 'auto' }}>
                        <h5 className="mb-0">Generados</h5>
                        <p>{formatNumberWithCommas(counters?.generated)}</p>
                      </div>
                      <div className="legend-item" style={{ minWidth: 'auto' }}>
                        <h5 className="mb-0">En proceso</h5>
                        <p>{formatNumberWithCommas(counters?.in_process)}</p>
                      </div>
                      <div className="legend-item" style={{ minWidth: 'auto' }}>
                        <h5 className="mb-0">Atendidos</h5>
                        <p>{formatNumberWithCommas(counters?.resolved)}</p>
                      </div>
                      <div className="legend-item" style={{ minWidth: 'auto' }}>
                        <h5 className="mb-0">Efectividad</h5>
                        <p>{counters?.effectiveness}%</p>
                      </div>
                    </div>
                    <div className="chart">
                      <KpiCustomGraphicBar
                        barDataStatus={counters?.counterByDateFilter}
                        barOptions={counters?.counterByDateFilterOptions}
                        showStackedDatalabels={true}
                      />
                      {showElementsController.dynamicTable && (
                        <div className="graphics-box-table">
                          <CategoriesTableAdminMasterMayor
                            counters={counters?.counterByDateFilterCategories}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              )}
              <div className="graphics-box col-12 mt-3">
                <div className="header">
                  <h5 className="text-left">
                    % de resueltos{' '}
                    {filters?.date_type === 'ALL'
                      ? 'total'
                      : filters?.date_type === 'YEAR'
                      ? 'anuales'
                      : filters?.date_type === 'MONTH'
                      ? 'mensuales'
                      : filters?.date_type === 'WEEK'
                      ? 'semanales'
                      : filters?.date_type === 'DAY'
                      ? 'diarios'
                      : 'total'}
                  </h5>
                </div>
                <div className="body">
                  <div className="chart">
                    <KpiCustomGraphicLine
                      lineData={counters?.counterByDateFilterLines}
                      lineOptions={counters?.counterByDateFilterLinesOptions}
                    />
                  </div>
                </div>
              </div>
              {showElementsController.graphicsPie && (
                <div className="col-12 mt-3">
                  <div className="row graphics-box graphics-boxPie">
                    <div className="header">
                      <h5 className="text-left">Reportes por canal</h5>
                    </div>
                    <div className="body">
                      <div className={`legend`}>
                        <div className="legend-item mr-3">
                          <h5>Web</h5>
                          <p>{formatNumberWithCommas(counters?.web)}</p>
                        </div>
                        <div className="legend-item mr-3">
                          <h5>App</h5>
                          <p>{formatNumberWithCommas(counters?.app)}</p>
                        </div>
                        <div className="legend-item">
                          <h5>Tlajochat</h5>
                          <p>{formatNumberWithCommas(counters?.tlajochat)}</p>
                        </div>
                      </div>
                      <div className="chart">
                        <KpiCustomGraphicPie
                          data={counters?.countersByDateFilterPie}
                          options={counters?.countersByDateFilterPieOptions}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default DashboardAdminMasterMayor
